import { useEffect, useState } from 'react';

import Alert from './components/Alert/Alert';
import CartItem from './components/CartItem/CartItem';
import { useTypedSelector } from '../../../lib/hooks/useTypedSelector';
import { useActions } from '../../../lib/hooks/useActions';
import downloadCsv from './downloadCsv';
import { Link, useNavigate } from 'react-router-dom';

import styles from './CartPage.module.scss';
import { Container } from '../../Container/Container';
import { numWord } from '../../../helpers/formatters';

import { postOrders } from '../../../api/orders/postOrder';
import Cookies from 'react-cookies';

import BackButton from '../../BackButton/BackButton';
import { getPart } from '../../../api/part/getPart';

const CartPage = () => {
  const [showContent, setShowContent] = useState(false);
  const navigate = useNavigate();
  const { cart } = useTypedSelector((state) => state);
  const { clearCart, removeItem } = useActions();

  const saveOrder = () => {
    if (Cookies.load('payload-token') && Cookies.load('isUser')) {
      postOrders(cart, Cookies.load('payload-token') || null).then((res) => {
        if (res) {
          clearCart();
          navigate('/account');
        }
      });
    }
  };

  useEffect(() => {
    cart.forEach((item) => {
      getPart(item.product_id)
        .then((resPart) => {
          if (resPart.status === 'discontinued' || !resPart.status) {
            removeItem({ product_id: item.product_id });
          }
        })
        .catch(() => {
          removeItem({ product_id: item.product_id });
        });
    });
    setShowContent(true);
  }, []);

  return (
    <Container>
      <div className={styles.CartPage}>
        {showContent ? (
          <>
            <div className={styles.holder}>
              <BackButton />
              <div className={styles.header}>
                <h1>
                  Корзина
                  {cart.length ? (
                    <span>
                      {' '}
                      / {cart.length}{' '}
                      {numWord(cart.length, ['позиция', 'позиции', 'позиций'])}
                    </span>
                  ) : null}
                </h1>
                {cart.length ? (
                  <div className={styles.buttons}>
                    <button
                      className={styles.clear}
                      onClick={() => clearCart()}
                    >
                      <img src="/icons/clear.svg" alt="cart" />
                      Удалить все
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
            <div className={styles.main}>
              {cart.length ? (
                <>
                  <div className={styles.content}>
                    <Alert
                      text={
                        'Заказ возможен только через авторизованные сервисные центры'
                      }
                    />
                    <div className={styles.itemsWrap}>
                      <div className={styles.items}>
                        {cart.map((item, index) => (
                          <CartItem {...item} key={index} />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className={styles.summary}>
                    <h2>Итого:</h2>
                    <ul className={styles.summaryFields}>
                      {cart.map((item, index) => (
                        <li key={`${item.article_number}-${index}`}>
                          <p>
                            {item.name?.length > 23
                              ? `${item.name.substring(0, 23)}...`
                              : item.name}{' '}
                          </p>
                          <span className={styles.summaryFieldsUnderline}>
                            {' '}
                          </span>
                          <span> {item.count} шт.</span>
                        </li>
                      ))}
                    </ul>
                    <div className={styles.confirm}>
                      <button
                        onClick={() => {
                          downloadCsv(cart);
                          saveOrder();
                        }}
                      >
                        Выгрузить файл
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <div className={styles.empty}>
                  <h2>Ваша корзина пуста</h2>
                  <p>
                    Перейдите в каталог для добавления 🛠️ запчастей или 🧰
                    аксессуаров
                  </p>
                  <Link to="/catalog">В каталог</Link>
                </div>
              )}
            </div>
            <div className={styles.itemsFile}>
              <h3>Инструменты SEB для ремонта и сервисного обслуживания</h3>
              <div className={styles.itemsFileUpload}>
                <img src="/icons/file.svg" alt="file" />
                <a
                  href="https://6e8ee6a6-c00b-40bb-a4ec-44a1c22bfeef.selstorage.ru/5aaa669e-9d46-4d24-a023-a3296c90bbb2.pdf"
                  target="_blank"
                  rel="noreferrer"
                  className={styles.link}
                >
                  Каталог.pdf (672 КБ)
                </a>
              </div>
            </div>
          </>
        ) : (
          'Загрузка...'
        )}
      </div>
    </Container>
  );
};

export default CartPage;
